module.exports = __webpack_public_path__ + "static/media/LXGWWenKai-Light.30af269a.ttf";